import { render, staticRenderFns } from "./CompanyProductsView.vue?vue&type=template&id=4f4d4551&scoped=true"
import script from "./CompanyProductsView.vue?vue&type=script&lang=js"
export * from "./CompanyProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d4551",
  null
  
)

export default component.exports